import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ErrorState {
  custom: boolean;
  status: number | null;
  message: string | null;
  isError: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorStateService {
  private initialState: ErrorState = {
    message: null,
    isError: false,
    custom: false,
    status: null,
  };

  private errorStateSubject = new BehaviorSubject<ErrorState>(
    this.initialState,
  );

  errorState$: Observable<ErrorState> = this.errorStateSubject.asObservable();

  setError(
    message: string,
    custom = false,
    status: number | null = null,
  ): void {
    this.errorStateSubject.next({
      message,
      isError: true,
      custom,
      status,
    });
  }

  clearError(): void {
    this.errorStateSubject.next(this.initialState);
  }

  getCurrentState(): ErrorState {
    return this.errorStateSubject.value;
  }
}
